import { render, staticRenderFns } from "./UserTermsOfServiceForm.vue?vue&type=template&id=1e34dc25"
import script from "./UserTermsOfServiceForm.vue?vue&type=script&lang=js"
export * from "./UserTermsOfServiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports